import PreferencesService from '../../services/preferences';
import i18n from '../../i18n';

const namespaced = true;

const state = {
  preferences: null,
  defaultMapView: null,
  defaultHomePage: null,
  loaded: false,
};

const getters = {
  preferences: (state) => state.preferences,
  defaultMapView: (state) => state.defaultMapView,
  defaultHomePage: (state) => state.defaultHomePage,
  loaded: (state) => state.loaded,
};

const mutations = {
  setPreferences(state, value) {
    state.preferences = value;
  },
  setDefaultMapView(state, value) {
    state.defaultMapView = value;
  },
  setDefaultHomePage(state, value) {
    state.defaultHomePage = value;
  },
  setLoaded(state, value) {
    state.loaded = value;
  },
};

const actions = {
  async loadMePreferences({ commit }) {
    try {
      const data = await PreferencesService.getMePreferences();
      commit('setPreferences', data || {});
      commit('setDefaultMapView', (data && data.defaultMapView) || null);
      commit('setDefaultHomePage', (data && data.defaultHomePage) || null);
      commit('setLoaded', true);
      return data;
    } catch (e) {
      commit('setPreferences', {});
      commit('setDefaultMapView', null);
      commit('setDefaultHomePage', null);
      commit('setLoaded', true);
      throw new Error(i18n.t('something-went-wrong'));
    }
  },

  async saveDefaultHomePage({ commit }, value) {
    try {
      const payload = { value };
      await PreferencesService.updateDefaultHomePage(payload);
      commit('setDefaultHomePage', value);
      return value;
    } catch (e) {
      throw new Error(i18n.t('something-went-wrong'));
    }
  },

  async saveDefaultMapView({ commit }, payload) {
    try {
      await PreferencesService.updateDefaultMapView(payload);
      commit('setDefaultMapView', payload);
      return payload;
    } catch (e) {
      throw new Error(i18n.t('something-went-wrong'));
    }
  },

  async clearDefaultMapView({ commit }) {
    try {
      await PreferencesService.deleteDefaultMapView();
      commit('setDefaultMapView', null);
      return true;
    } catch (e) {
      throw new Error(i18n.t('something-went-wrong'));
    }
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
